import { Flex } from 'modules/ui';
import styled from 'styled-components';

export const InfoCardWrapper = styled(Flex)`
  margin-bottom: 2rem;
  margin-top: 1rem;
  max-width: 55rem;
`;
